module.exports = __webpack_public_path__ + "static/media/wichita.5680494e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wichita.png
// module id = 239
// module chunks = 0